import { render, staticRenderFns } from "./SftpDetailsDialogForCasualSenders.vue?vue&type=template&id=1e21037a&scoped=true&"
import script from "./SftpDetailsDialogForCasualSenders.vue?vue&type=script&lang=js&"
export * from "./SftpDetailsDialogForCasualSenders.vue?vue&type=script&lang=js&"
import style0 from "./SftpDetailsDialogForCasualSenders.vue?vue&type=style&index=0&id=1e21037a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e21037a",
  null
  
)

export default component.exports